export default __webpack_public_path__ + "static/media/185-2BR.b0993ca5.svg";